import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=72467618&"
import script from "./CompanySettings.vue?vue&type=script&lang=ts&"
export * from "./CompanySettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports